module.exports = __webpack_public_path__ + "static/8-c1855d3a0df5f8f5cfc6af74ef039fdd.jpg";